import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CiWarning } from "react-icons/ci";

import AlertContainer from './components/alert/alertContainer.js';
import PromptContainer from './components/prompt/promptContainer.js';
import LoadingView from './views/Loading/LoadingView';
import LoginView from './views/Login/LoginView.js';
import PageFacade from './views/PageFacade';
import PassportExpiredView from './views/Expired/PassportExpiredView.js';
import LoginDialogue from './components/login/LoginDialogue.js';
import TextKeyboardComponent from './components/keyboards/TextKeyboardComponent';
import NumericKeyboardComponent from './components/keyboards/NumericKeyboardComponent';

var translator = require('./utils/translator/translator');
var logger = require('./utils/logger/logger');
var staffUtility = require('./utils/domain/staff/staffUtility');
var stringUtil = require('./utils/string/stringUtil.js');
var dateUtil = require('./utils/dateUtil/dateUtil.js');
var businessDateUtil = require('./utils/dateUtil/businessDateUtil.js');
var stateManager = require('./utils/state/stateManager.js');
var passportExpiredAction = require('./utils/state/actions/passport/passportExpiredAction.js');

class App extends Component 
{
    constructor(props)
    {
        super(props);
        this.expirePassportIfRequire = this.expirePassportIfRequire.bind(this);
        
        this.state = {};
        this.state.suspendedMessageDismissed = false;
    }

    componentDidMount() 
    {
        this.timerID = setInterval
        (
          () => 
          {
                this.expirePassportIfRequire();
          },
          1000 * 60 * 15
        );      //After every 15 minutes
    }

    render()
    {
        return <div className='h-100'>
                    <AlertContainer/>
                    <PromptContainer/>
                    <div className='h-100'>
                        {this.renderInternetConnectionErrorMessage()}
                        {this.renderAppComponent()}
                        {this.renderLoginDialogue()}
                        {this.renderOnScreenKeyboard()}
                    </div>
                </div>
    }

    renderAppComponent()
    {
        if (!this.props.applicationInitialized)
          return <LoadingView/>

        if (this.props.passportExpired)
          return <PassportExpiredView/>
        
        if (this.props.staffLoginData == null)
            return <LoginView></LoginView>;
          
        return <PageFacade params={this.props.navigationPage}/>
    }

    renderInternetConnectionErrorMessage()
    {
        if (!this.props.applicationInitialized)
            return;

        if (!this.props.internetConnectionSuspended)
            this.state.suspendedMessageDismissed = false;

        if (!this.props.internetConnectionSuspended && !this.props.internetConnectionDisconnected)
            return null;

        if (this.props.internetConnectionDisconnected)
        {
            return <div style={{position:'fixed', top:0, 
                            border:'1px solid black', 
                            background:'orange', color:'white', width:'100vw', height:'6px', fontSize:'1.1rem', zIndex:9999}}>

            </div>
        }

        if (this.state.suspendedMessageDismissed)
            return <div style={{position:'fixed', top:0, 
                            border:'1px solid black', 
                            background:'red', color:'white', width:'100vw', height:'6px', fontSize:'1.1rem', zIndex:9999}}>

                    </div>

        return <div style={{position:'fixed', top:0, left:'25vw', whiteSpace:'nowrap',
                            border:'1px solid black', borderRadius:10, textAlign:'center', 
                            paddingTop:'5px', paddingBottom:'5px',
                            background:'red', color:'white', width:'50vw', fontSize:'1.1rem', zIndex:9999}}>
                    
                    <table>
                        <tr>
                            <td>
                                <span style={{marginLeft:'5px'}}>
                                    <CiWarning fontSize="1.5rem" style={{marginTop:'-5px'}}/>
                                </span>
                            </td>
                            <td style={{width:'99%', textAlign:'center'}}>
                                <span>
                                    {translator.getLabel("disconnected_check_internet")} 
                                </span>
                            </td>
                            <td>
                                <span style={{marginRight:'10px'}}
                                      onClick={()=>
                                      {
                                            if (this.props.staffLoginData == null || this.props.staffLoginData.staff == null)
                                                return;

                                            logger.warn(`Internet disconnection message is dismissed by staff: ${staffUtility.getLoginStaffCompleteName()}`);

                                            this.state.suspendedMessageDismissed = true;
                                            this.setState({})
                                      }}>{translator.getLabel("dismiss")}</span>
                            </td>
                        </tr>
                    </table>
                    
               </div>
    }

    renderLoginDialogue()
    {
        if (this.props.loginDialogue == null)
            return  null;

        return <LoginDialogue pinAllowed={this.props.loginDialogue.pinAllowed} 
                              onLogin={this.props.loginDialogue.onLogin}/>
    }

    renderOnScreenKeyboard()
    {
        if (this.props.onScreenKeyboard == null)
            return null;

        let component = null;
        if (this.props.onScreenKeyboard.keyboardType == "text")
            component = <TextKeyboardComponent onScreenKeyboardContext={this.props.onScreenKeyboard}/>
        else
            component = <NumericKeyboardComponent onScreenKeyboardContext={this.props.onScreenKeyboard}/>

        return <div style={{position:'fixed', bottom:0, marginBottom:'10px', zIndex:9999}}>  
                    {component}
                </div>
    }

    expirePassportIfRequire()
    {
        if (!this.props.applicationInitialized || 
            stringUtil.isStringNullOrEmpty(this.props.applicationInitializationDateTime) ||
            this.props.passportExpired)
        {
            return;
        }

        let todaysBusinessDate = businessDateUtil.getTodayBusinessDate();
        let applicationInitializationBusinessDate = businessDateUtil.getPropertyBusinessDateFromUtcDateTime(this.props.applicationInitializationDateTime);
        if (!dateUtil.isSame(todaysBusinessDate, applicationInitializationBusinessDate))
        {
            logger.info("Passport is expired, triggering the passport expiry action")
            stateManager.getStore().dispatch(passportExpiredAction.createAction(true));
        }
    }
}

const mapStateToProps = state => 
{
    if (!state.applicationInitialized)
    {
        return {
                    applicationInitialized: state.applicationInitialized,
               }
    }

    return { 
              applicationInitialized: state.applicationInitialized,
              applicationInitializationDateTime: state.applicationInitializationDateTime,
              staffLoginData: state.staffLoginData,
              internetConnectionSuspended: state.internetConnectionSuspended,
              internetConnectionDisconnected: state.internetConnectionDisconnected,
              loginDialogue: state.loginDialogue,
              onScreenKeyboard: state.onScreenKeyboard,
              navigationPage: state.navigationPage,
              passportExpired: state.passportExpired
          }
}

export default connect(mapStateToProps)(App)
